import * as createCampaigns from 'store/actions/campaigns/createCampaigns';
import * as deleteCampaigns from 'store/actions/campaigns/deleteCampaigns';
import * as fetchCampaigns from 'store/actions/campaigns/fetchCampaigns';
import * as types from 'store/actions/types';
import * as updateCampaigns from 'store/actions/campaigns/updateCampaigns';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* fetchCampaignsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/funnels`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchCampaigns.fetchCampaignsSuccess(response));
    } catch (error) {
        yield put(fetchCampaigns.fetchCampaignsFailure(error));
    }
}

function* fetchCampaignsAccumulatedAsync({ payload }) {
    const params = payload.params || {
        size: payload.size,
        offset: payload.offset,
        sort_by: payload.sort.field,
        sort_direction: payload.sort.order,
    };

    yield fetchCampaignsAsync({
        payload: params,
    });
}

function* fetchCampaignAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/funnels/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchCampaigns.fetchCampaignSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchCampaigns.fetchCampaignFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createCampaignAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/funnels`;

        const response = yield apiClient.create(url, values);

        yield put(createCampaigns.createCampaignSuccess(response));

        yield onSuccess();
    } catch (error) {
        yield put(createCampaigns.createCampaignFailure(error));

        yield onError(error);
    }
}

function* createCampaignSuccessAsync() {
    yield put(showNotification('notifications.campaigns.create.success'));
}

function* updateCampaignAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/funnels/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateCampaigns.updateCampaignSuccess(payload, response));

        yield onSuccess();
    } catch (error) {
        yield put(updateCampaigns.updateCampaignFailure(error));

        yield onError(error);
    }
}

function* updateCampaignSuccessAsync() {
    yield put(showNotification('notifications.campaigns.update.success'));
}

function* deleteCampaignAsync({ payload }) {
    const { id } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/funnels/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteCampaigns.deleteCampaignSuccess(payload));
    } catch (error) {
        yield put(deleteCampaigns.deleteCampaignFailure(error));
    }
}

function* deleteCampaignSuccessAsync() {
    yield put(showNotification('notifications.campaigns.remove.success', 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* campaignsSagas() {
    yield [
        takeEvery(types.FETCH_CAMPAIGNS, fetchCampaignsAsync),
        takeEvery(types.FETCH_CAMPAIGNS_ACCUMULATED, fetchCampaignsAccumulatedAsync),
        takeEvery(types.FETCH_CAMPAIGNS_FAILURE, failureMessage),

        takeEvery(types.FETCH_CAMPAIGN, fetchCampaignAsync),
        takeEvery(types.FETCH_CAMPAIGN_FAILURE, failureMessage),

        takeEvery(types.CREATE_CAMPAIGN, createCampaignAsync),
        takeEvery(types.CREATE_CAMPAIGN_FAILURE, failureMessage),
        takeEvery(types.CREATE_CAMPAIGN_SUCCESS, createCampaignSuccessAsync),

        takeEvery(types.UPDATE_CAMPAIGN, updateCampaignAsync),
        takeEvery(types.UPDATE_CAMPAIGN_FAILURE, failureMessage),
        takeEvery(types.UPDATE_CAMPAIGN_SUCCESS, updateCampaignSuccessAsync),

        takeEvery(types.DELETE_CAMPAIGN, deleteCampaignAsync),
        takeEvery(types.DELETE_CAMPAIGN_FAILURE, failureMessage),
        takeEvery(types.DELETE_CAMPAIGN_SUCCESS, deleteCampaignSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/campaignsSagas.js